import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import {
  vaultWarningActionBtnSx,
  vaultWarningBannerSx,
  vaultWarningContentSx,
  vaultWarningTextSx,
} from '../css/revenueItems.styles';

export const VaultWarningIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0 }} aria-hidden>
    <path d="M10 2L18.66 17H1.34L10 2Z" stroke="#eab308" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M10 8v4" stroke="#eab308" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="10" cy="14.5" r="0.75" fill="#eab308" />
  </svg>
);

const VaultNotConfiguredBanner = ({ message, actionLabel, onAction, sx }) => (
  <Box sx={{ ...vaultWarningBannerSx, ...sx }}>
    <Box sx={vaultWarningContentSx}>
      <VaultWarningIcon />
      <Typography sx={vaultWarningTextSx}>{message}</Typography>
    </Box>
    {actionLabel && onAction ? (
      <Button variant="outlined" onClick={onAction} sx={vaultWarningActionBtnSx}>
        {actionLabel}
      </Button>
    ) : null}
  </Box>
);

export default VaultNotConfiguredBanner;
